import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import { useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Outlet } from "react-router-dom";
import { adminNavigation } from "./constants/menus";
export default function MainLayout() {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#f0f0f0]">
      <div className="fixed top-0 left-0 right-0 z-40">
        <TopBar>
          <Sheet open={isMobileNavOpen} onOpenChange={setIsMobileNavOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="xl:hidden">
                <Menu className="h-6 w-6" />
                <span className="sr-only">Toggle navigation menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent
              side="left"
              className="p-0 w-48 xl:w-72 max-w-xs bg-gray-50"
            >
              <Sidebar
                menu={adminNavigation}
                close={() => setIsMobileNavOpen(false)}
              />
            </SheetContent>
          </Sheet>
        </TopBar>
      </div>
      <div className="pt-[80px] flex h-svh">
        <div className="hidden xl:block w-[98px] z-30">
          <Sidebar menu={adminNavigation} />
        </div>
        <main className="flex-1">
          <Outlet />
        </main>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}
